module.exports = __webpack_public_path__ + "static/media/notification-success.61a80e87.svg";